// extracted by mini-css-extract-plugin
module.exports = {"returns":"_72de1b9","potentialReturns":"_47bc104","potentialReturnsPriceChange":"_bea7e13","promotion":"_05f8f7f"};